/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import { uniq } from 'lodash/fp';
import { slideInDown } from 'react-animations';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { padding } from 'polished';

import lineUpSelector from 'app/selectors/lineUpSelector';
import t from 'app/utils/translate';

type Props = {
  isRacing?: boolean,
  lineUp: Array<Object>,
  minGamesPerEntry?: number,
  playersPerGame?: Object,
  requiredSelections: number
};

const slideAnimation = keyframes(slideInDown);

const Info = styled.div(({ theme }) => ({
  animationDuration: '0.5s',
  animationName: slideAnimation,
  backgroundColor: theme.color.info,
  color: 'white',
  fontSize: '0.875rem',
  ...padding(5, 10),
  position: 'relative',
  textTransform: 'uppercase',
  zIndex: -1
}));

const defaultProps = {
  minGamesPerEntry: undefined,
  playersPerGame: undefined
};

function MaxedFixturePlayersInfo({
  isRacing,
  lineUp,
  minGamesPerEntry,
  playersPerGame,
  requiredSelections
}: Props) {
  const gameIds = uniq(lineUp.map(player => player.gameId));

  if (
    isRacing ||
    lineUp.length === 0 ||
    minGamesPerEntry <= 1 ||
    lineUp.length === requiredSelections ||
    requiredSelections - lineUp.length > minGamesPerEntry - gameIds.length
  ) {
    return null;
  }

  return (
    <Info>
      <span className="ion-ios-information" />{' '}
      {t('Maximum players reached from an individual fixture')}
    </Info>
  );
}

MaxedFixturePlayersInfo.defaultProps = defaultProps;

const connector = connect(
  state => ({
    isRacing: state.challenge.isRacing,
    lineUp: lineUpSelector(state),
    minGamesPerEntry: state.challenge.minGamesPerEntry,
    playersPerGame: state.challenge.playersPerGame,
    requiredSelections: state.challenge.playerQuota + state.challenge.teamQuota
  }),
  null
);

export default connector(MaxedFixturePlayersInfo);
